import { Container, Paper, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import './ContactMe.css'
import { send } from 'emailjs-com';


const ContactMe = () => {
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = data => {
        if (data.name === '' || data.mobile === '' || data.email === '') {
            return;
        }
        // console.log(data)
        send(
            'service_1qrq82i',
            'template_0ibqpxh',
            data,
            'user_UDnNrkdwD7RZV6rkbkLk7'
        )
            .then(res => {
                console.log(res);
            });  
        reset()
    };
    return (
        <Container sx={{mt: 10}}>
            <Paper elevation={0} style={{ padding: 10, backgroundColor: '#f5f5f5'}}>
                <Typography id="contact" style={{fontWeight: 600, fontSize: '280%', textAlign: 'center', marginBottom: 30, marginTop: 20}} variant="h2" component="div" gutterBottom>
                    Get in Touch
                </Typography>
                <form className="contactForm" onSubmit={handleSubmit(onSubmit)}>

                    <label htmlFor="name">Name<span style={{color: 'red'}}>*</span> </label>
                    <input
                        id="name"
                        placeholder="Your Name"
                        {...register("to_name")}
                        required
                    />

                    <label htmlFor="mobile">Mobile No.<span style={{color: 'red'}}>*</span></label>
                    <input
                        id="mobile"
                        type="tel"
                        placeholder="Your Mobile No."
                        {...register("mobile")}
                        required
                    />

                    <label htmlFor="email">Email<span style={{color: 'red'}}>*</span></label>
                    <input
                        id="email"
                        type="email"
                        placeholder="Your Email"
                        {...register("reply_to")}
                        required
                    />
                    
                    <label htmlFor="queries">Your Queries<span style={{color: 'red'}}>*</span></label>
                    <textarea
                        id="queries"
                        placeholder="....."
                        {...register("message")}
                        style={{ resize: 'none' }}
                        required
                    ></textarea>

                    <button className="btnSubmit" type="submit">Submit</button>
                </form>
            </Paper>
        </Container>
    );
};

export default ContactMe;